import React, { Component } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';

function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
}

class TranslationsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: [],
            left: [0, 1, 2, 3],
            right: [4, 5, 6, 7],
            leftChecked: true,
            rightChecked: true
        }
    }

    componentDidMount() {
        this.setState({
            leftChecked: intersection(this.state.checked, this.state.left),
            rightChecked: intersection(this.state.checked, this.state.right)
        })        
    }

    handleToggle = (value) => () => {
        const currentIndex = this.state.checked.indexOf(value);
        const newChecked = [...this.state.checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        this.setState({ checked: newChecked })
    };

    handleAllRight = () => {
        this.setState({
            right: this.state.right.concat(this.state.left),
            left: []
        })
    };

    handleCheckedRight = () => {
        this.setState({
            right: this.state.right.concat(this.state.leftChecked),
            left: not(this.state.left, this.state.leftChecked),
            checked: not(this.state.checked, this.state.leftChecked)
        })
    };

    handleCheckedLeft = () => {
        this.setState({
            left: this.state.left.concat(this.state.rightChecked),
            right: not(this.state.right, this.state.rightChecked),
            checked: not(this.state.checked, this.state.rightChecked)
        })
    };

    handleAllLeft = () => {
        this.setState({
            left: this.state.left.concat(this.state.right),
            right: []
        })
    };

    customList = (items) => (
        <Paper sx={{ width: 200, height: 350, overflow: 'auto' }}>
            <List dense component="div" role="list">
                {items.map((value) => {
                    const labelId = `transfer-list-item-${value}-label`;

                    return (
                        <ListItem
                            key={value}
                            role="listitem"
                            button
                            onClick={this.handleToggle(value)}
                        >
                            <ListItemIcon>
                                <Checkbox
                                    checked={this.state.checked.indexOf(value) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': labelId,
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={`Forge ${value + 1}`} />
                        </ListItem>
                    );
                })}
                <ListItem />
            </List>
        </Paper>
    );

    render() {
        return (
            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                <Grid container spacing={3}>

                    <Grid item xs={12} md={12} lg={6}>

                        <Paper
                            sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                height: 450,
                            }}
                        >
                            <h2>Translations</h2>
                            <Grid container spacing={2} justifyContent="center" alignItems="center">
                                <Grid item>{this.customList(this.state.left)}</Grid>
                                <Grid item>
                                    <Grid container direction="column" alignItems="center">
                                        <Button
                                            sx={{ my: 0.5 }}
                                            variant="outlined"
                                            size="small"
                                            onClick={this.handleAllRight}
                                            disabled={this.state.left.length === 0}
                                            aria-label="move all right"
                                        >
                                            ≫
                                        </Button>
                                        <Button
                                            sx={{ my: 0.5 }}
                                            variant="outlined"
                                            size="small"
                                            onClick={this.handleCheckedRight}
                                            disabled={this.state.leftChecked.length === 0}
                                            aria-label="move selected right"
                                        >
                                            &gt;
                                        </Button>
                                        <Button
                                            sx={{ my: 0.5 }}
                                            variant="outlined"
                                            size="small"
                                            onClick={this.handleCheckedLeft}
                                            disabled={this.state.rightChecked.length === 0}
                                            aria-label="move selected left"
                                        >
                                            &lt;
                                        </Button>
                                        <Button
                                            sx={{ my: 0.5 }}
                                            variant="outlined"
                                            size="small"
                                            onClick={this.handleAllLeft}
                                            disabled={this.state.right.length === 0}
                                            aria-label="move all left"
                                        >
                                            ≪
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid item>{this.customList(this.state.right)}</Grid>
                            </Grid>

                        </Paper>
                    </Grid>


                    <Grid item xs={12} md={12} lg={6}>

                        <Paper
                            sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                height: 450,
                            }}
                        >
                            <h2>Vendor Data</h2>

                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        )
    }
}

export default TranslationsView;